module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER TWO")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("K")])]), _vm._v("yra lowered her Glock when she saw Gabe Stanford, the Flamingo Cay police chief, and another officer hurrying down the path toward her. For the first time since she’d heard the muffled noise of the first gunshot she relaxed her tense muscles, rolling her head to work the aches out of her neck and shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gabe stopped in front of her, a little out of breath. “This isn’t the way I envisioned us meeting when your aunt told me you were finally coming home for a visit.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Smiling at the man who had been her inspiration to become a law-enforcement officer, she went to him and gave him a hug. “Me neither. I came back for my first vacation in six years and got caught up in a murder.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gabe frowned, peered back at the officer and said, “I’ve got this, Connors. You can go back and help Wilson.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The large thirtysomething man nodded and retraced his steps toward Pelican Lane.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What happened here? I was checking the yard by the swamp and heard gunshots.” Gabe glanced down at the Glock.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I returned the killer’s fire. He ran out of the Pattersons’, and I went after him. He shot twice at me then got "), _c('a', {
    attrs: {
      "id": "page16"
    }
  }), _vm._v("into a motorboat and went that way.” Kyra pointed to the south.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did you get a good look at him?” He holstered his gun.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. He was too far away and his head was turned from me. He was wearing camouflage pants and shirt, boots and a ball cap, pulled down low on his forehead. He was about six feet, slender build. That’s all I got. Sorry.” As a police officer for twelve years before founding Guardians, Inc., she knew the importance of a detailed and correct description of an assailant.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s better than a lot I’ve gotten. Did you see the man kill either victim back at the Pattersons’?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shook her head. “I did see him shoot at a girl who fled the scene. I don’t think he hit her. I thought he might be going after her so I took off after him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s the girl look like?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sixteen, maybe seventeen. She was wearing jeans and a T-shirt. Black hair.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you think the killer had her in the boat?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kyra shook her head. “Not from what I saw. Is the guy in the bedroom still alive?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, he didn’t have a chance.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I didn’t think he would even with immediate medical help. I’ve seen nasty gunshot wounds like he had, and they usually don’t end well.” Remembering the young man on the tile floor by the sliding glass door only reinforced why she left the police force. Six years ago she’d seen too much death and had needed to do something different. She’d still wanted to help make this world a safer place, but she couldn’t continue investigating one murder after another. The Lord had something else in mind for her. Guardians, Inc. gave her the sense she was helping others without being personally involved in so much death.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gabe began walking back toward the crime scene. "), _c('a', {
    attrs: {
      "id": "page17"
    }
  }), _vm._v("“That’s what I thought, but we called the local doctor who lives down the street to help. The victim died before Dr. Hunt could do anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Michael Hunt, Ginny’s little brother?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yep, he’s all grown up and has returned to Flamingo Cay to run the medical clinic. We’ve needed another doctor in town for quite some time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The Michael Hunt she remembered used to follow her and Ginny, her best friend in high school, around generally making life difficult for them. She’d known from Ginny her little brother had gone on to be a doctor, but she hadn’t seen him in years. The last time she’d heard about him, he’d been practicing in Chicago, so she hadn’t thought she would see him in Flamingo Cay.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Michael came back about four months ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As they neared the edge of the swamp, Kyra’s tension returned, gripping her neck and fanning out along her shoulders. “I thought you were retiring.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This is my last year.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She tilted her head. “Promise? When I was home for Dad’s funeral, didn’t you say that to me? I thought you meant it that time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Two years ago there wasn’t anyone I felt could take over for me, but Wilson is a good man. He should do fine when I retire.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kyra emerged from the heavy foliage that marked the beginning of the swamp that made up the Everglades. Flamingo Cay, not too far from Naples, was between the Glades and the Gulf of Mexico with its many islands off Florida’s western coast.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She caught sight of a large man over six feet tall carrying a black bag, standing on the side deck off the bedroom talking to an officer. At that moment Michael glanced over his shoulder at her. For a few seconds their gazes linked "), _c('a', {
    attrs: {
      "id": "page18"
    }
  }), _vm._v("across the yard. Then recognition dawned on his face, and he smiled at her, two dimples appearing and bringing back more memories of her childhood. Even as a kid he’d had a great smile—one that drew people to him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Tell me what happened here.” Gabe paused in the side yard, returning her attention to the problem at hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kyra reluctantly wrenched her look from Michael Hunt. “I was out on the beach after my aunt left to go walk with a friend at the track. I’d taken my towel and beach bag out there to just enjoy the sunrise and read and relax. Before I had a chance, I heard muffled gunshots. A young man stumbled out onto the beach from the Pattersons’ backyard, collapsed and mumbled something about helping them, then died. I knew someone else was in trouble. I had my gun, so I called 911 and went to see if I could help.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You might not be a detective anymore, but it’s hard to get it out of your system.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Instinct. I was a cop for a lot of years.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Can you tell me anything else about the girl besides age and hair color?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She’s pale, not much of a tan, with heavily made-up eyes in black. The color of them, though, was blue. When she glanced up at me, she looked so scared. But she kept going, which saved her life. The killer got off a shot, but she disappeared down the deck steps. I didn’t see which way she went because I was focused on the assailant in the hallway. He never came into the room. He might have sensed me there. Maybe he saw a reflection in the sliding glass door. I don’t know. I checked the rooms down the hallway, and that’s when I found the other victim. Then I saw the killer running toward the swamp. I felt I had to go after him in case he was pursuing the girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gabe rubbed his chin. “Hmm. The teenage girl could be Amy, Michael’s younger sister.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page19"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The one Ginny was raising until she went to the Philippines as a missionary?” Her childhood friend’s little sister? If anything had happened to the girl, she would have been at a loss how to tell Ginny.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yup. Amy said she would run away before she’d go to the Philippines. She wanted to finish high school this coming year in Flamingo Cay. Michael agreed to come home and take care of her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kyra slanted her glance toward Michael striding toward them. His medium-length black hair lay at odd angles as though he’d run his hand through it multiple times. Even from a distance his blue eyes, so much like the teenage girl’s when Kyra thought about it, lured her in. Compelling. Captivating. Even better than his smile. She dragged her attention away from his gaze, fastening it onto the cleft in his chin, then his full lips, which were tugged in a look of concern.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gabe greeted Michael with a handshake. “Thanks for coming.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I was too late. I don’t think there was anything I could have done, though.” Michael’s look shifted to her. “Kyra Morgan?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She nodded. “It’s been a long time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sixteen years. I think the last time I saw you was the summer right before I went to college. It’s good to see you.” He held out his hand to her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She fit hers in his clasp, and his large fingers surrounded hers. The connection, warm, full of strength, further surprised her. “How’s Ginny doing? I haven’t heard from her since she went to the Philippines.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Getting settled in.” A smile leaked through the tired lines about his eyes and mouth, and he wiped moisture off his brow. “I forgot how bad the humidity could get here, especially in the summer. It takes some getting used to.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page20"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know. I had planned on spending a lot of time in the water to counter that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gabe cleared his throat. “I hate to break up this little reunion, but Michael, where is Amy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“At home. Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gabe fully faced Michael. “She may have been involved with what went down here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michael’s tanned features paled. “No, that’s not possible. Amy wouldn’t hurt anyone. She won’t even eat meat because animals are being killed to provide it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I saw a teenage girl fleeing from the house. She had blood on her hands and shirt.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michael shook his head. “Not Amy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gabe pointed toward the house. “The person dead on the beach is Preston Stevens. Hasn’t Amy been seeing him?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not lately. She promised me.” Panic seized Michael’s cobalt-blue eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I want Kyra to meet her. If it’s not the same girl she saw in the bedroom, then that’s the end of it. If Amy was there, I need to talk to her. She’s the only one left to tell us what happened before Kyra came on the scene,” Gabe said using his usual laid-back approach, all the while assessing his surroundings and the situation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wanted to reassure Michael about his sister, to wipe that apprehensive expression from his face. “I don’t think she had anything to do with either killing. The girl I saw was scared. The assailant I chased into the swamp shot at her but didn’t hit her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michael gritted his jaws together so tightly a nerve jerked in his cheek. “Fine. I’m sure this is all a mistake.” A vulnerability beneath his words infused his voice with doubt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You said she’s at home. There’s no time like the pres"), _c('a', {
    attrs: {
      "id": "page21"
    }
  }), _vm._v("ent to get this straightened out.” Gabe started around to the back of the house and the beach, skirting Connors, who was with Preston’s body, putting up crime-scene tape while another officer was talking to some of the neighbors outside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michael hung back, opening and closing his hands at his sides. He peered at Preston lying faceup on the beach, then back at Kyra.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She approached him. “You’re not so sure, are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shook his head, bleakness in his eyes. “Not the way Amy has been acting lately. The first month I was back here everything was all right. Then at the start of the summer, she began to change into the little sister that Ginny warned me about.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wild, rebellious, stubborn.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Some of that describes a typical teenager. I can remember some of the things I pulled with Ginny.” She grinned. “And you took pleasure in letting your mom know all about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For a fleeting second humor flashed into his eyes until his gaze fixed upon a point down the beach. Kyra turned and saw Gabe waiting for them four houses down.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“When we get this all straightened out, I hope we can talk.” Michael began walking. “The one thing I know about Amy is she wouldn’t hurt anyone. Just last week a bird flew into the glass window. She had me out there trying to revive it. I kept telling her I was a doctor for humans, not birds.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kyra fell into step next to him as he passed near the crime-scene tape. “Did the bird make it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For a long moment Michael didn’t say anything, only stared at Preston, a dark shadow in his eyes. Finally he blinked, shook his head slightly and focused on Kyra. "), _c('a', {
    attrs: {
      "id": "page22"
    }
  }), _vm._v("“Yes, Twitter flew off an hour later as if nothing had happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Twitter?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Amy named the bird that. Now do you see why I don’t think she could have been involved? It had to be someone else.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sometimes people get caught up in something they never intended.” Kyra touched his arm and stopped on the beach, compelling him to do likewise. “I used to investigate homicides for a living.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, Ginny told me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You talked to Ginny about me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You were Ginny’s best friend, even if you two didn’t get to see each other much in the past few years.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t know about y’all, but I have a lot to do,” Gabe shouted, his fists on his hips, his glare directed at them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I forgot how impatient he can be,” Kyra said with a laugh and continued her trek toward the police chief. “My point in telling you that is if Amy is involved I might be able to help you.” The second the words were out of her mouth, Kyra wanted to snatch them back. Help Michael? How? She was only going to be here a week. Besides, what business was it of hers? She had so needed a break finally. Gabe was quite capable of finding the killer without her help.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This little reunion will have to wait, y’all. Where’s Amy?” Gabe charged up the back steps to the deck and waited at the door while his foot tapped against the wooden planks. “We haven’t had a murder in Flamingo Cay in four years, and now I’ve got two in one day.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michael reached around Gabe and opened one of the double glass doors. “She went to her bedroom. I’ll go get her. Have a seat.” He waved toward the den, then headed down the hall.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page23"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Before going into Michael’s place, Kyra slipped off her swamp-soaked tennis shoes and strode to the outside water faucet and rinsed the mud off her legs and sneakers. After setting them out to dry, she entered the house.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gabe removed his ball cap and scratched his thinning hair. “I’ve got a bad feeling about this.” Then he plopped the hat—a sore subject with the town council, which thought he should wear his complete uniform—back on his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why do you say that?” Kyra asked as the sound of rushed footsteps resonated down the corridor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A second later Michael appeared, his eyes huge, fear carving deep lines into his face. “She’s not in there.” He brought forward a bloody T-shirt. “But this was on the floor.” His hand quavered as he thrust it toward Gabe.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This is Amy’s?” Gabe asked, making no move to take the article of clothing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes. She was wearing it yesterday.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kyra headed toward the kitchen but paused in the entrance. “And this morning when you saw her?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t know. I didn’t see what she had on. All I saw was a glimpse of her before Wilson called me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where’s a paper sack?” Kyra had known the Hunt family for years, and although she and Ginny didn’t see each other in person much anymore, they did keep in touch by phone and email occasionally. Now she knew why she’d told Michael she would help—because of the years of friendship.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In the top of the pantry. Why?” Michael clamped the edge of the T-shirt between his thumb and forefinger.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("While she rummaged around in the pantry, Kyra heard Gabe explain about putting the shirt in the sack as evidence. When she found what she was looking for behind some pans, she returned to the living room. His forehead "), _c('a', {
    attrs: {
      "id": "page24"
    }
  }), _vm._v("furrowed, Michael dropped the piece of clothing into the evidence bag.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I need to take a look at the house. Is that okay?” Gabe asked, taking the sack.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Confusion clouding his eyes, Michael glanced from Gabe to Kyra. She gave him a nod, and he said, “Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Kyra, do you want to help?” Gabe crossed toward the hallway. “I could always use an extra pair of eyes. In fact, I could hire you as a consultant so you could work this case. I could use your expertise as a homicide detective. Besides, you’ve seen more murders than me, and one of my officers is on vacation.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How about the sheriff and his deputies or the state police?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll put a call in for some help, but I don’t know how much I’ll get until next week. They’re gonna be busy on St. Cloud Island. A big symposium on terrorism is being held there soon with some world leaders attending. I think something else is happening on Marco Island. Some big conference with the governor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She couldn’t turn down Gabe’s request when he was the reason she’d become a police officer in the first place. “Sure, if you need me, I’ll help but you don’t have to hire me as a consultant. I’ll poke around and see what I can come up with.” She twisted toward Michael, wanting to erase the worry from his face. “I didn’t see a gun on the floor by the body, and I didn’t see Amy with one. I think the only one who had a gun was the assailant.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He peered at her as though she were speaking a foreign language.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Preston and the other guy were shot. So where’s her gun if she shot them?” Kyra asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michael’s eyes brightened. “Yeah. But why did she run away?”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page25"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She was scared. People often react without thinking. Do you know any reason why she would go to the Pattersons’ house?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shook his head, the light dimming again in his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She closed the space between them. “I told Gabe I would help, and I will.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My most immediate concern is finding Amy. If the man shot at her, then he may be after her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She couldn’t dispute that—it was a very real possibility. “He fled into the swamp.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She loves the swamp. What if he was going after her?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His every word held such alarm that Kyra was drawn again to comfort Michael. She touched his arm, his bicep bunching beneath her fingertips. “The sequence of events doesn’t support that. You were seeing her in this house while I was going after the killer.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then where did she go?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good question. We need to find her.” As Gabe disappeared down the hallway, Kyra inhaled deeply, smelling Michael’s scent—musk and antiseptic. “While we’re looking around, try calling her first then start calling her friends, if she doesn’t answer her cell. See if she’s with one of them or they know where she would go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can do that.” He dug into his pocket and withdrew his cell. “I also need to call my partner to tell him to cover for me for the next few days.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kyra left him making the first call. She seriously doubted Amy was over at a friend’s, but it gave Michael something to do while they searched the house. The person she’d seen running from the murder scene was frightened. What had Amy witnessed? What did Michael’s sister know that caused the assailant to shoot at her? Could Amy ID the killer?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When she entered the teen’s bedroom, Gabe closed a "), _c('a', {
    attrs: {
      "id": "page26"
    }
  }), _vm._v("drawer. “I’m worried about Amy. If she witnessed a double homicide, the killer might not rest until he finds her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I agree.” Kyra strolled toward a pegboard with photos pinned on it. She surveyed the array. “I haven’t seen pictures of Amy since she was much younger. But this is definitely the girl I saw at the house.” She tapped her finger at a girl in a photo in the center of the board—two girls, arms slung over each other’s shoulders, huge smiles on their faces.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s Amy. I know that she has been in more trouble this past year than before, but I would never figure she would be involved in a murder even as a witness.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Can you tell me anything about Preston? Why would someone want to kill him? Who is the other victim?” Kyra used the eraser end of a pencil to wake up Amy’s computer. Amy’s screen saver came blazing to life. A scene of a swamp—dark, eerie, with deep shadows except where a sunray burst through the thick foliage to light the murky water.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Preston is—was a bit on the wild side. I’ve seen Amy and him together around town. I’m not sure who the other guy is. He must be passing through. Wilson is working on that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Could he have been involved in drugs?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Possibly. You think this is drug-related?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You know that drug dealers have used the Glades to smuggle in their poison so it’s a very real possibility.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, that’s what I’m afraid of. A few years back I would have said Amy would never have been caught up in something like that. Now I can’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Which means she could be in deeper trouble than just the police looking for her to question her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yup. The killer could be after her as a witness or a drug deal gone bad.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page27"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It won’t be the first time a murderer wants to silence a witness or a dealer wants to send a message about double-crossing him.” Noticing Amy’s internet server was still open, Kyra sat at the desk and punched some keys to bring up the girl’s email account. She clicked on the last message Amy sent. “Gabe, come look at this.” She peered over her shoulder at her mentor and glimpsed Michael standing in the doorway.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Both men approached the desk.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michael hovered over Kyra to read, “I lost my cell at the cabin. He’s got it. Gotta get out of here. Hide. Meet me at our place.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52c555d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter-02.vue
// module id = 72
// module chunks = 0